// FutureLab
import { ChatListDataInterface } from '../components/chat/ChatListItemsMobile';
import { UserDetailsListItem } from '../model';
import { LoggedInUserDetails } from '../reducers/index';
import { isSameUserId, toUserId } from './UserId';

export function returnOneToOneChatUserDetails(
	chatListItem: ChatListDataInterface,
	loggedInUserDetails: LoggedInUserDetails,
	userListProfilesDetails: UserDetailsListItem[]
): UserDetailsListItem | undefined {
	const loggedInUserId = toUserId(loggedInUserDetails?.id);
	if (!loggedInUserId) {
		return undefined;
	}

	let oneToOnechatRoomUser = chatListItem?.participants?.find(
		(participant) => !isSameUserId(participant?.userId, loggedInUserId)
	);
	if (!oneToOnechatRoomUser) {
		oneToOnechatRoomUser = chatListItem?.participants?.find(
			(participant) => isSameUserId(participant?.userId, loggedInUserId)
		);
	}
	const oneToOnechatRoomUserDetails = userListProfilesDetails?.find(
		(participant) => isSameUserId(participant?.id, oneToOnechatRoomUser?.userId)
	);

	return oneToOnechatRoomUserDetails;
}

export function getUserDisplayName(
	user: Pick<UserDetailsListItem, 'firstname' | 'lastname'> | undefined,
	fallback = 'Unknown user'
) {
	const name = [user?.firstname, user?.lastname]
		.map((part) => part?.trim())
		.filter(Boolean)
		.join(' ');
	return name || fallback;
}

export function getMissingUserIds(userIds: Array<number | string>, profiles: UserDetailsListItem[]) {
	const loadedIds = new Set(profiles.map((profile) => Number(profile.id)).filter(Number.isFinite));
	return Array.from(new Set(userIds.map(Number).filter(Number.isFinite))).filter((userId) => !loadedIds.has(userId));
}
